import { ChainName, NATIVE_TOKEN_ADDRESS, WRAPPED_GAS_TOKENS } from '@src/configs/chainInfo'
import { CHAIN_IDS } from '@src/configs/chainInfo'
import { isFeatureEnabled } from '@src/utils/environment'

/**
 * Maps Solana USDC address to its corresponding EVM address
 * @param tokenAddress The original token address
 * @param isQuote Optional flag to handle null address differently for quotes
 * @param chainIdOrName Optional chain ID or name to get the correct wrapped token address
 * @param onChainExecution Optional flag to indicate if the address will be used in an on-chain transaction (defaults to false)
 * @returns The mapped token address or the original if no mapping exists
 */
export const mapTokenAddress = (
    tokenAddress: string,
    isQuote = false,
    chainIdOrName: ChainName | number,
    onChainExecution = false
): string => {
    const chainId = typeof chainIdOrName === 'string' ? CHAIN_IDS[chainIdOrName] : chainIdOrName

    // Special case: If tokenAddress is 'native' and onChainExecution is true, we need to use the wrapped token
    if (tokenAddress === 'native' && onChainExecution && isFeatureEnabled('V2_MIGRATION')) {
        if (chainId && WRAPPED_GAS_TOKENS[chainId]) {
            return WRAPPED_GAS_TOKENS[chainId].address
        }
    }

    // Handle native token addresses in quotes
    if (isQuote && tokenAddress === NATIVE_TOKEN_ADDRESS[chainId]) {
        // For V2 API, use 'native' for native tokens, but only if not for on-chain execution
        if (isFeatureEnabled('V2_MIGRATION') && !onChainExecution) {
            return 'native'
        }

        // For V1 API or on-chain execution, convert native to wrapped gas token
        if (chainIdOrName) {
            // Convert chain name to ID if a string is provided
            if (chainId && WRAPPED_GAS_TOKENS[chainId]) {
                return WRAPPED_GAS_TOKENS[chainId].address
            }
        }
    }

    return tokenAddress || ''
}
